<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';
import { useLoading } from 'vue-loading-overlay'
import Layout from "@/layouts/mainfw.vue";
import PageHeader from "@/components/page-header";
import { useFastWay } from "@/state/modules/fastway";
import Dialog from '@/views/components/Dialog.vue';
import Confirm from '@/views/components/Confirm.vue';
import { TextBoxComponent } from "@syncfusion/ej2-vue-inputs";

const apiFW = require('@/api.config.js');
const router = useRouter();
const route = useRoute();
const store = useFastWay();
const loader = useLoading();
let id = ref(0);
let loaded = ref(false);
let editing = ref(false);
let dialog = ref(null);
let dialogDelete = ref(null);
let confirm = ref(null);
let data = ref(null);
let data_local = ref({
  id: 0,
  parameter: '',
  code: '',
  value: ''
});
const title = "Parámetros";
const items = [
  {
    text: "Infraestructura",
    href: "/",
  },
  {
    text: "Parámetros",
    href: "/infra/parameters",
  },
  {
    text: "Parámetro",
    active: true,
  }
];

const api = computed({
    get() {
      return apiFW.default.apiURL;
    }
});

onMounted(async () => {
  id.value = parseInt(route.params.id);
  getData(id.value);
});

const getData = async (id) => {
  if (id == 0) {
    loaded.value = true;
    editing.value = true;
  } else {
    const loading = loader.show({loader: 'bars', color: '#0000FF'}, {after: () => 'Cargando lista de valores'});
    const params = {
      objectId: id,
      userId: store.userInfo.userId,
      token: store.userInfo.token
    };
    await axios
    .post(`${api.value}/parameters/data`, params)
    .then(response => {
      if (response.data.success) {
        if (response.data.data) {
          data.value = response.data.data;
          data_local.value = JSON.parse(JSON.stringify(response.data.data));
        }
      } else {
        dialog.value.show('error', `Error interno al cargar parámetro ${id}`, response.data.message);
      }
      loaded.value = true;
      loading.hide();
    })
    .catch(error => {
      loaded.value = true;
      loading.hide();
      dialog.value.show('error', `Error al cargar parámetro ${id}`, error.message);
    });
  }
};

const resetData = () => {
  if (id.value == 0) {
    router.push({name: 'parameters'});
  } else {
    data_local.value = JSON.parse(JSON.stringify(data.value));
    editing.value = false;
  }
};

const validateForm = () => {
  let validated = true;
  if (!data_local.value.parameter || data_local.value.parameter == '') {
    dialog.value.show('error', 'Error al guardar parámetro', 'Debe especificar un parámetro');
    validated = false;
  } else if (!data_local.value.code || data_local.value.code == '') {
    dialog.value.show('error', 'Error al guardar parámetro', 'Debe especificar un código');
    validated = false;
  }
  return validated;
};

const save = async () => {
  if (validateForm()) {
    const loading = loader.show({loader: 'bars', color: '#0000FF'}, {after: () => 'Guardando parámetro'});
    data_local.value.id = id.value;
    data_local.value.parameter = data_local.value.parameter.toUpperCase();
    data_local.value.code = data_local.value.code.toUpperCase();
    data_local.value.context = store.userInfo;
    data_local.value.createdBy = store.userInfo.userId;
    await axios
    .post(`${api.value}/parameters/save`, data_local.value)
    .then(response => {
      loading.hide();
      if (response.data.success) {
        data.value = JSON.parse(JSON.stringify(data_local.value));
        editing.value = false;
        dialog.value.show('success', 'Información', 'Datos han sido actualizados');
        if (id.value== 0) {
          router.push({
            name: 'parameter',
            params: {id: response.data.data.id}
          });
        }
      } else {
        dialog.value.show('error', 'Error interno al actualizar', response.data.message);
      }
    })
    .catch(error => {
      loading.hide();
      dialog.value.show('error',  `Error al actualizar parámetro ${id.value}`, error.message);
    });
  } 
};

const remove = async () => {
  const loading = loader.show({loader: 'bars', color: '#0000FF'}, {after: () => 'Eliminando parámetro'});
  const parms = {
    objectId: id.value,
    userId: store.userInfo.userId,
    token: store.userInfo.token
  };
  await axios
  .post(`${api.value}/parameters/delete`, parms)
  .then(response => {
    loading.hide();
    if (response.data.success) {
      dialogDelete.value.show('success', 'Información', 'Parámetro fue eliminado correctamente');
    } else {
      dialog.value.show('error', 'Error interno al eliminar', response.data.message);
    }
  })
  .catch(error => {
    loading.hide();
    dialog.value.show('error', `Error al eliminar parámetro ${id.value}`, error.message);
  });
};

const add = () => {
  router.push({
    name: 'parameter',
    params: {id: 0}
  });
  id.value = 0;
  data_local.value = {
    id: 0,
    parameter: '',
    code: '',
    value: ''
  };
  editing.value = true;
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
     <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center align-middle row ms-0 me-0 mb-2">
                        <div v-if="!editing" class="col d-flex justify-content-start">
                          <b-button variant="success" class="btn-label waves-effect waves-light" v-b-tooltip.hover title="Agregar parámetro" @click="add"><i class="las la-plus label-icon"></i> Agregar</b-button>
                        </div>
                        <div class="col"/>
                        <div class="input-group col justify-content-end">
                          <b-button v-if="editing" variant="primary" class="btn-label waves-effect waves-light" v-b-tooltip.hover title="Guardar cambios efectuados" @click="save"><i class="las la-save label-icon"></i> Guardar</b-button>
                          <b-button v-if="editing" variant="warning" class="btn-label waves-effect waves-light" v-b-tooltip.hover title="Descartar cambios efectuados" @click="resetData"><i class="las la-undo label-icon"></i> Cancelar</b-button>
                          <b-button v-if="!editing" variant="primary" class="btn-label waves-effect waves-light" v-b-tooltip.hover title="Editar información" @click="editing = true"><i class="las la-edit label-icon"></i> Editar</b-button>
                          <b-button v-if="!editing" variant="danger" class="btn-label waves-effect waves-light" v-b-tooltip.hover title="Eliminar parámetro" @click="confirm.show('Confirme', '¿Está seguro de eliminar este parámetro?')"><i class="las la-trash label-icon"></i> Eliminar</b-button>
                        </div>
                    </div>
                    <hr>
                    <div class="mb-1">
                      <TextBoxComponent v-model:value="data_local.parameter" floatLabelType="Auto" placeholder="Parámetro" :disabled="!editing"/>
                    </div>
                    <div class="mb-1">
                      <TextBoxComponent v-model:value="data_local.code" floatLabelType="Auto" placeholder="Código" :disabled="!editing"/>
                    </div>
                    <div class="mb-1">
                      <TextBoxComponent v-model:value="data_local.value" floatLabelType="Auto" placeholder="Valor" :disabled="!editing"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Dialog ref="dialog"/>
    <Dialog ref="dialogDelete" @accept="router.push({name: 'parameters'});"/>
    <Confirm ref="confirm" @accept="remove"/>
  </Layout>
</template>
